/** @file The drawable point of a node, entity-relative and unrounded: node position plus its turned offset. */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { PoseBuffer } from '@zilo/pose3d-pose/contract';
import { poseNodeOf } from '@zilo/pose3d-render-core/place/poseNodeOf';
import { rotateZScaled } from '@zilo/pose3d-pose/chain/rotateZScaled';

/** `N + Zs(q, s offset)` with s the node's scale (21.4 rule 2; originOffset is already in N, R1). */
export function worldPointOf(pose: PoseBuffer, nodeIndex: number, offset: Vec3, zScaleRotate: number): Vec3 {
  const { pos, q, scale } = poseNodeOf(pose, nodeIndex);
  const r = rotateZScaled(q, [offset[0] * scale, offset[1] * scale, offset[2] * scale], zScaleRotate);
  return [pos[0] + r[0], pos[1] + r[1], pos[2] + r[2]];
}
